import { COMPONENT_DEFAULT } from 'constants';
import { useRef } from 'react';

const useDrawer = ({ drawer = COMPONENT_DEFAULT }) => {
  const drawerRef = useRef();

  const handleOnToggleNavbar = () => {
    if (!drawerRef?.current) {
      console.error(
        `🔥 useDrawer ❌ handleOnToggleNavbar ➡️ drawerRef is empty ↩`
      );
      return;
    }
    console.log(`⭐ useDrawer 👉 handleOnToggleNavbar ➡️ RUNNING ↩`);
    drawerRef?.current?.handleOnToggleNavbar();
  };

  return {
    renderDrawerComponent: () =>
      drawer({
        drawerRef,
        handleOnToggleNavbar,
      }),
  };
};

export default useDrawer;
